import { message, Modal } from "antd";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AddRoleModalConsts } from "./constants";
import { useQueryClient } from "@tanstack/react-query";
import RolesServices from "../../../../../services/roles.services";
import TNLoader from "../../../../../reusable-components/TNLoader";
import { InputfieldTypes } from "../../../../../enums/InputFieldAttributesEnums";
import InputField from "../../../../../reusable-components/TNInputField";

interface AddRoleModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const AddRoleModal = ({ isOpen, handleClose }: AddRoleModalProps) => {
  const queryClient = useQueryClient();
  const { reset, handleSubmit, getValues, setValue } = useFormContext();
  const { TITLE, LABEL, FIELD_NAME, PLACEHOLDER, ADD_SUCCESS_MSG, ZINDEX } =
    AddRoleModalConsts;

  const { AddExternalRoleEntry } = RolesServices();

  const { mutateAsync: addRole, isPending: addRolePending } =
    AddExternalRoleEntry({ isCrm: true });

  const handleCancel = () => {
    reset();
    handleClose();
  };

  const handleSave = async () => {
    const roleNameValue = getValues(FIELD_NAME);
    await addRole(roleNameValue, {
      onSuccess: () => {
        message.success(ADD_SUCCESS_MSG);
      },
      onError: (error) => {
        message.error(error?.response?.data?.message);
      },
    });
    queryClient.invalidateQueries();
    handleCancel();
  };

  return (
    <>
      <TNLoader isLoading={addRolePending} />
      <Modal
        title={TITLE}
        visible={isOpen}
        onCancel={handleCancel}
        closable={true}
        onOk={() => {
          handleSubmit(handleSave)();
        }}
        zIndex={ZINDEX}
      >
        <InputField
          type={InputfieldTypes.TEXT}
          label={LABEL}
          name={FIELD_NAME}
          placeholder={PLACEHOLDER}
          requiredField={true}
        />
      </Modal>
    </>
  );
};

export default AddRoleModal;
